import React from "react";
import { view } from "@orderofchaos/mvvm";
import {
  GoogleLoginWidgetViewModel,
  type GoogleLoginWidgetViewProps,
} from "./GoogleLoginWidgetViewModel";
import styles from "./GoogleLoginWidget.module.css";

type GoogleLoginWidgetProps = GoogleLoginWidgetViewProps & {
  className?: string;
};

export const GoogleLoginWidget: React.FC<GoogleLoginWidgetProps> = view(
  GoogleLoginWidgetViewModel,
)<GoogleLoginWidgetProps>(({ className = "", viewModel: { containerRef } }) => {
  return <div ref={containerRef} className={`${styles.root} ${className}`} />;
});
